module.exports = __webpack_public_path__ + "static/img/me.a52e48d.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/me.jpeg
// module id = HSz3
// module chunks = 1